import { StyleSheet } from 'react-native';

import { neutralDark, peacock, warrior } from '../../../constants/color';

const styles: any = StyleSheet.create({
  retryContainer: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 3,
  },
  retryBtn: {
    alignItems: 'center',
    borderColor: neutralDark,
    borderRadius: 3,
    borderWidth: 1,
    flex: 1,
    paddingVertical: 12,
  },
  retryText: {
    color: warrior,
  },
  disable: {
    opacity: 0.4,
  },
  atmMaintain: {
    color: peacock,
    marginTop: 7,
  },
});

export default styles;
